import styled from '@emotion/styled';


export const Spacer = styled.div`
  height: ${({ h }) => h || 0}px;
  width: ${({ w }) => w || 0}px;
`;
